import BranchOrderDestinationSection from 'components/pages/dashboard/parcelOrderForBranch/components copy/destinationBranch/BranchOrderDestinationSection';
import BranchOrderOriginSection from 'components/pages/dashboard/parcelOrderForBranch/components copy/origin/BranchOrderOriginSection';
import BranchOrderRowWrapper from 'components/pages/dashboard/parcelOrderForBranch/components copy/origin/components/BranchOrderRowWrapper';
import BranchOrderParcelSection from 'components/pages/dashboard/parcelOrderForBranch/components copy/parcel/BranchOrderParcelSection';
import { packageCreate } from 'global/Models/omOrderModel';
import { FC, useMemo } from 'react';
import { BsArrowDownSquare, BsArrowLeftSquare } from 'react-icons/bs';

interface IOrderRow {
  index: number;
  pack: packageCreate;
  deleteRow: (_index: number) => void;
  packages: packageCreate[];
  setPackages: React.Dispatch<React.SetStateAction<packageCreate[]>>;
  copyByIndex: (_index: number) => void;
  useLocker: boolean;
}

const BranchOrderRow: FC<IOrderRow> = ({ index, pack, deleteRow, packages, setPackages, copyByIndex, useLocker }) => {
  const renderIconsBetweenBoxes = useMemo(
    () => (
      <>
        <div className='items-center hidden lg:flex '>
          <BsArrowLeftSquare />
        </div>
        <div className='items-center mx-auto md:hidden '>
          <BsArrowDownSquare />
        </div>
      </>
    ),
    []
  );

  return (
    <BranchOrderRowWrapper index={index} pack={pack} copyByIndex={copyByIndex} deleteRow={deleteRow} useLocker={useLocker}>
      <div className='flex flex-col justify-between gap-4 p-2 lg:flex-row '>
        <div className='p-2 border border-dashed rounded-xl border-t-secondary-text-color'>
          <BranchOrderOriginSection setPackages={setPackages} packages={packages} index={index} />
        </div>
        {renderIconsBetweenBoxes}
        <div className='p-2 overflow-y-auto border border-dashed max-h-[100vh] rounded-xl border-t-secondary-text-color'>
          <BranchOrderParcelSection setPackages={setPackages} packages={packages} index={index} />
        </div>
        {renderIconsBetweenBoxes}
        <div className='p-2 border border-dashed rounded-xl border-t-secondary-text-color'>
          <BranchOrderDestinationSection setPackages={setPackages} packages={packages} index={index} />
        </div>
      </div>
    </BranchOrderRowWrapper>
  );
};

export default BranchOrderRow;
